import {Alert} from 'platform/components';
import {Show} from 'platform/foundation';

import {isNotNil} from 'ramda-adjunct';

import {UserResponseBody} from '@dms/api/shared';
import i18n from '@dms/i18n';

import {Nullish, RequiredTestIdProps, suffixTestId} from 'shared/web';

import {isUserInactive} from '../../utils/isUserInactive';

interface DeletedUserAlertProps extends RequiredTestIdProps {
  // The user list a picker was fed, including any persisted assignee re-injected
  // by `useUsersWithPersistedAssignee`.
  users: UserResponseBody[];
  // The user id currently selected in the picker.
  selectedUserId: string | Nullish;
}

/**
 * Inline warning rendered under a user picker when its current selection points
 * to a deleted user (re-injected by `useUsersWithPersistedAssignee`).
 * Non-blocking: it nudges a reassignment without preventing save.
 */
export function DeletedUserAlert(props: DeletedUserAlertProps) {
  const selectedUser = props.users.find((user) => user.id === props.selectedUserId);
  const isSelectedUserDeleted = isNotNil(selectedUser) && isUserInactive(selectedUser);

  return (
    <Show when={isSelectedUserDeleted}>
      <Alert
        variant="warning"
        type="inline"
        message={i18n.t('entity.user.labels.deletedUser')}
        data-testid={suffixTestId('deletedUserAlert', props)}
      />
    </Show>
  );
}
